'use strict';

angular.module('msCore').directive('msAgeInput', ['countryGdprConfig', function (countryGdprConfig) {

  var _link = function _link(scope, element, attr, ngModelCtrl) {
    ngModelCtrl.$parsers.push(function (dob) {
      // expects Jackson date format: [Year, Month (1-indexed), day (of month)]
      if (!angular.isArray(dob) || dob.length !== 3) {
        ngModelCtrl.$setValidity('error', true);
        return dob;
      }
      var minAge = countryGdprConfig.getFromStorage().minAge;
      var momentDob = moment({ year: dob[0], month: dob[1] - 1, day: dob[2] });
      var age = moment.duration(moment().diff(momentDob)).asYears();
      ngModelCtrl.$setValidity('tooOld', age < 150);
      ngModelCtrl.$setValidity('whoops', age > 0 && age < 500);
      ngModelCtrl.$setValidity('age_' + minAge, age >= minAge);

      return dob;
    });
  };

  return {
    restrict: 'A',
    require: 'ngModel',
    link: _link
  };
}]);